import { Box, type BoxProps, Button, forwardRef } from '@chakra-ui/react';

import { useEmptyStyles } from './EmptyStylesContext';

export type EmptyCTAButtonProps = BoxProps;

/**
 * A call-to-action Button for users to click to resolve an empty state. Optional part of the multipart `Empty` component. Composes `Button`.
 */
export const EmptyCTAButton = forwardRef<EmptyCTAButtonProps, 'div'>(
  ({ as = Button, children, ...restProps }, ref) => {
    const { ctaButton: ctaButtonStyles } = useEmptyStyles();

    return (
      <Box as={as} ref={ref} __css={ctaButtonStyles} {...restProps}>
        {children}
      </Box>
    );
  },
);
EmptyCTAButton.displayName = 'EmptyCTAButton';
